import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
import { AgencyAssignableRoleSchema } from "./agency-auth.js";
export const StudioWorkItemIdSchema = z.string().min(1).max(80);
export const StudioWorkItemStatusV1Schema = z.enum(["OPEN", "ASSIGNED", "DONE", "CANCELLED"]);
export const StudioWorkItemV1Schema = z
    .object({
    schemaId: z.literal("studio.workItem.v1"),
    id: StudioWorkItemIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    title: z.string().min(1).max(200),
    status: StudioWorkItemStatusV1Schema,
    assigneeUserId: z.string().min(1).nullable(),
    createdByUserId: z.string().min(1).nullable(),
    assignedAt: z.string().datetime().nullable(),
    lifecycleVersion: z.number().int().min(0),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const StudioWorkItemCreateRequestV1Schema = z
    .object({
    schemaId: z.literal("studio.workItemCreateRequest.v1"),
    title: z.string().min(1).max(200),
    assigneeUserId: z.string().min(1).optional(),
})
    .strict();
export const StudioWorkItemAssignRequestV1Schema = z
    .object({
    schemaId: z.literal("studio.workItemAssignRequest.v1"),
    assigneeUserId: z.string().min(1),
    expectedLifecycleVersion: z.number().int().min(0),
})
    .strict();
export const StudioWorkItemListV1Schema = z
    .object({
    schemaId: z.literal("studio.workItemList.v1"),
    items: z.array(StudioWorkItemV1Schema),
})
    .strict();
export const StudioAssignableUserV1Schema = z
    .object({
    schemaId: z.literal("studio.assignableUser.v1"),
    userId: z.string().min(1),
    email: z.string().email(),
    name: z.string().nullable(),
    role: AgencyAssignableRoleSchema,
})
    .strict();
export const StudioAssignableUserListV1Schema = z
    .object({
    schemaId: z.literal("studio.assignableUserList.v1"),
    items: z.array(StudioAssignableUserV1Schema),
})
    .strict();
export const StudioWorkItemMutationResultV1Schema = z
    .object({
    schemaId: z.literal("studio.workItemMutationResult.v1"),
    ok: z.literal(true),
    workItem: StudioWorkItemV1Schema,
    nextAction: z.string().min(1).optional(),
})
    .strict();
//# sourceMappingURL=studio-work-item.js.map